import { PropsWithChildren } from 'react';
import {
  FieldValues,
  FormProvider,
  SubmitErrorHandler,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';

export interface FormContainerProps<TFormValues> extends PropsWithChildren {
  form: UseFormReturn<TFormValues>;
  onSubmit: SubmitHandler<TFormValues>;
  onError?: SubmitErrorHandler<TFormValues>;
  formId?: string;
  className?: string;
}

export default function FormContainer<
  TFormValues extends FieldValues = FieldValues,
>(props: FormContainerProps<TFormValues>) {
  const { form, onSubmit, onError, children, formId, className } = props;

  return (
    <FormProvider {...form}>
      <form
        noValidate
        autoComplete="off"
        onSubmit={form.handleSubmit(onSubmit, onError)}
        id={formId}
        className={className}
      >
        {children}
      </form>
    </FormProvider>
  );
}
